import { useState } from "react";
import { Table, DatePicker, InputNumber, Button, message } from "antd";
import { Scatter, Column } from '@ant-design/charts';
import dayjs from "dayjs";
import { fetchLifeTimeValue } from "../../apis/statisticsApi";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const LifeTimeValue = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [periodMonths, setPeriodMonths] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchStats = async () => {
    if (!startDate || !endDate) {
        message.warning("Por favor selecciona ambas fechas.");
        return;
    }
    if (!periodMonths || periodMonths < 1) {
        message.warning("Por favor selecciona un período válido.");
        return;
    }
    if (!dayjs.utc(startDate).isBefore(dayjs.utc(endDate), "day")) {
        message.warning("La fecha de inicio debe ser anterior a la fecha de fin.");
        return;
    }
    setLoading(true);
    try {
        const res = await fetchLifeTimeValue(dayjs.utc(startDate).format("YYYY-MM-DD"), dayjs.utc(endDate).format("YYYY-MM-DD"), periodMonths);
        setData(res.data);
    } catch (err) {
        console.error("Error fetching lifetime value stats:", err);
        message.error("Error al cargar estadísticas");
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Inicio del período",
      dataIndex: "period_start",
      key: "period_start",
      render: d => dayjs.utc(d).format("DD/MM/YYYY"),
    },
    {
      title: "Fin del período",
      dataIndex: "period_end",
      key: "period_end",
      render: d => dayjs.utc(d).format("DD/MM/YYYY"),
    },
    {
      title: "Usuarios nuevos",
      dataIndex: "users_count",
      key: "users_count",
    },
    {
      title: "Promedio días de vida",
      dataIndex: "avg_lifetime_days",
      key: "avg_lifetime_days",
    },
  ];

  // Prepare data for the bubble chart
  const chartData = data.map(row => ({
    period: `${dayjs.utc(row.period_start).format("DD/MM/YYYY")} - ${dayjs.utc(row.period_end).format("DD/MM/YYYY")}`,
    users_count: Number(row.users_count),
    avg_lifetime_days: Number(row.avg_lifetime_days), // Ensure it's a number
  }));

  const scatterConfig = {
    data: chartData,
    xField: 'period',
    yField: 'avg_lifetime_days',
    sizeField: 'users_count',
    size: [10, 50], // min and max bubble size
    pointStyle: { fillOpacity: 0.7 },
    shapeField: 'point',
    colorField: 'period',
    legend: false,
    height: 500,
  };

  // Bar chart config
  const barConfig = {
    data: chartData,
    xField: 'period',
    yField: 'avg_lifetime_days',
    color: '#5B8FF9',
    height: 400,
    xAxis: {
      title: { text: 'Período' },
      label: { autoHide: false, autoRotate: true },
    },
    yAxis: {
      title: { text: 'Promedio días de vida' },
    },
    legend: false,
  };

  return (
    <div className="container">
      <h2 className="text-center mb-3">Life Time Value</h2>
      <div style={{ display: "flex", gap: 16, marginBottom: 32 }}>
        <div>
          <span>Fecha inicio: </span>
          <DatePicker
            value={startDate}
            onChange={setStartDate}
            format="YYYY-MM-DD"
          />
        </div>
        <div>
          <span>Fecha fin: </span>
          <DatePicker
            value={endDate}
            onChange={setEndDate}
            format="YYYY-MM-DD"
          />
        </div>
        <div>
          <span>Meses por período: </span>
          <InputNumber
            min={1}
            max={12}
            value={periodMonths}
            onChange={setPeriodMonths}
          />
        </div>
        <Button type="primary" onClick={fetchStats} loading={loading}>
          Consultar
        </Button>
      </div>
      <Scatter {...scatterConfig} style={{ marginBottom: 32 }} />
      <Column {...barConfig} style={{ marginBottom: 32 }} />
      <Table
        columns={columns}
        dataSource={data}
        rowKey={row => `${row.period_start}_${row.period_end}`}
        loading={loading}
        pagination={false}
      />
    </div>
  );
};

export default LifeTimeValue;